export default {
  // Lägen
  "common.mode.auto": "Självförbrukning",
  "common.mode.economy": "Ekonomiskt läge",
  "common.mode.exigency": "Nödläge",

  // Utrustning
  "common.grid": "Elät",
  'common.evChargers': 'Laddstationer',
  'common.evCharger': 'Laddstation',
  'common.pv': 'Solceller',
  'common.inverter': 'Omvandlare',
  'common.pcs': 'Omvandlare + Batteri',
  'common.terminal': 'Slutenhet',
  'common.airc': 'Luftkonditionering',
  'common.engine': 'Motor',
  'common.battery': 'Batteri',
  'common.metter': 'Elmätare',
  'common.other': 'Övrigt',
  "common.power": "Effekt",
  "common.powerTotal": "Total effekt",
  "common.voltage": "Spänning",
  "common.electricity": "Elmängd",
  "common.current": "Ström",
  "common.homeUsage": "Hushållets totala last",
  "common.battery.power": "Batterieffekt",

  // Data
  "common.noDataAvailable": 'Ingen data tillgänglig för tillfället~',
  'common.tips': 'Tips',
  "common.reset": "Återställ",
  "common.currencyUnit": '¥',
  "common.submiting": 'Skickar, var god vänta...',
  "common.close": 'Stäng',
  "common.from": 'Från',
  "common.useIn": 'Används i',
  "common.energyPercent": 'Energiflödesandel',
  "common.dataFlow": "Dataflöde",
  "common.getDataIng": 'Hämtar data, var god vänta...',
  "common.pageLoading": 'Sidan laddas, var god vänta...',
  "common.reseting": "Sidan återställs, var god vänta...",
  "common.save": 'Spara',
  "common.onlyNumberTips": "Endast siffror kan anges",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault":"Fel",
  "common.charge": "Laddning",
  "common.discharge": "Urladdning",
  "common.buy": "Köp",
  "common.sell": "Sälj",
  "common.loadingInfo": 'Laddar, var god vänta...',

  //
  "common.moreFeatures": "Fler funktioner",
  "common.confirm": 'Bekräfta',
  "common.saveing": "Sparar, var god vänta...",
  "common.searchPlacholder": "Ange söknyckelord",
  "common.iSee": 'Jag förstår',
  "common.pageErrorTips1": "Hoppsan, sidfel uppstod~",
  "common.pageErrorTips2": "Försök uppdatera sidan eller kontakta kundservice~",
  "common.refresh": "Uppdatera",
  "common.backToHome": "Tillbaka till startsidan",
  "common.checkTips": "Kontrollerar, var god vänta...",
  "common.back": "Tillbaka",
  "common.cancel": "Avbryt",
  "common.optional": "Valfritt",
  "common.required": "Obligatoriskt",
  "common.status": "Status",
  "common.statusNoDelete": "Inte raderad",
  "common.statusDelete": "Raderad",
  "common.submit": 'Skicka',
  "common.disable": "Inaktivera",
  "common.enable": "Aktivera",
  "common.year": 'år',
  "common.month": 'månad',
  "common.day": 'dag',
  "common.version": 'Versionsnummer:',
  "common.backHome": ' Tillbaka till startsidan',
  "common.backHomeSorry": ' Ledsen, sidan har gått vilse',
  "common.requestTips1": 'Data bearbetas, skicka inte igen',
  "common.requestTips2": "Systemmeddelande",
  "common.requestTips3": "Inloggningsstatus har upphört, logga in igen",
  "common.requestTips4": "Logga in igen",
  "common.requestTips5": "Ogiltig session, eller session har upphört, logga in igen.",
  "common.requestTips6": "Serverfel, försök igen senare.",
  "common.requestTips7": "Timeout för begäran till systemgränssnitt",
  "common.requestTips8": 'Systemgränssnitt',
  "common.requestTips9": 'Fel',
  "common.iknow": 'Jag förstår',
  "common.logoutSuccess": "Utloggning lyckades",

  // Lär dig mer komponent
  "common.knowMore.title": 'Vill du veta mer, kontakta BeiNeng',
  "common.knowMore.email": 'E-post',
  "common.knowMore.phone": 'Telefon',
  "common.knowMore.wechat": 'WeChat',
  "common.knowMore.website": 'Hemsida',
  "common.knowMore.address": 'Adress',
  "common.knowMore.addressDetail": 'Rum 1205 och 1301, Byggnad 5, No. 8 Qinghe Road, Huangjingkeng, Huangjiang Town, Dongguan City, Guangdong Province',

  // Lokal anslutning komponent
  "common.localConnection": 'Lokal anslutning',
  "common.operateInApp": 'Vänligen utför åtgärden i appen!',

  "common.enbleStaus": "Aktiveringsstatus",
  "common.battery.status": "Varken laddar eller urladdar",

  'account.forgetThePassword': 'Glömt lösenordet',
    'account.logInDirectly': 'Gå direkt till inloggning',
    'account.tips1': 'Omdirigerar, var god vänta...',
    'account.tips2': 'Läs och godkänn användarvillkoren först!',
    'account.autoLogin': 'Auto-inloggning',
    'account.userLogin': 'Användarinloggning',
    'account.registerTips': 'Inget konto än? Klicka här för att registrera dig',
    'account.userEmail': 'Användarnamn/E-post',
    'account.userEmailTips': 'Ange användarnamn/e-post',
    'account.password': 'Lösenord',
    'account.passwordTips': 'Ange lösenord',
    'account.submit': 'Skicka',
    'account.submitTips': 'Skickar, var god vänta...',
    'account.otherLoginTips': 'Eller välj annat inloggningssätt',
    'account.userRegistration': 'Användarregistrering',
    'account.userName': 'Användarnamn',
    'account.userNameTips': 'Ange användarnamn',
    'account.emailTips1': 'Ange e-postadress',
    'account.emailTips2': 'Ogiltig e-postadressformat',
    'account.phone': 'Telefonnummer',
    'account.phoneTips1': 'Ange telefonnummer',
    'account.phoneTips2': 'Ogiltigt telefonnummer',
    'account.phoneTips3': 'Ange telefonnummer',
    'account.passwordTips1': 'Ange lösenord på 6-30 tecken',
    'account.passwordTips2': 'Ogiltigt lösenordsformat. Lösenordet måste bestå av bokstäver, siffror, understreck, bindestreck och punkter, 6-12 tecken långt.',
    'account.passwordTips3': 'Lösenorden matchar inte, kontrollera och försök igen!',
    'account.passwordTips4': 'Ange lösenord. Lösenordet måste bestå av bokstäver, siffror, understreck, bindestreck och punkter.',
    'account.passwordTips5': 'Bekräfta lösenord',
    'account.passwordTips6': 'Ange bekräftelselösenord',
    'account.passwordTips7': 'Lösenorden matchar inte, kontrollera och försök igen!',
    'account.passwordTips8': 'Ange bekräftelselösenord',
    'account.passwordTips9': 'Grattis! Registreringen lyckades!',
    'account.passwordTips10': 'Ditt användarnamn är:',
    'account.emailIs': 'E-post är:',
    'account.goToLoginPage': 's kommer automatiskt att omdirigeras till inloggningssidan',
    'account.goLogin': 'Logga in',
    'account.goRegister': 'Registrera',
    'account.loginSuccess': 'Inloggning lyckades',
    'account.email': 'E-post',
    'account.sologn': 'Skräddarsydda energilösningar med omtanke',
    'account.pleaseAgree': 'Jag har läst och godkänt',
    'userAgreement.privacyPolicy': 'Integritetspolicy',

    "account.code": "Verifieringskod",
    "account.codeTips": "Ange verifieringskod",
    "account.codeTips2": "Ogiltig verifieringskod",

    "account.inviteCodeTips": "Ange inbjudningskod",
    "account.inviteCodeHint": "Kontakta installatören eller driftpersonalen för att få inbjudningskoden",
    "account.modifyPasswordByAccount": "Ändra lösenord via konto",
    "account.modifyPasswordByEmail": "Ändra lösenord via e-post",
    "account.getPasswordByAccount": "Återställ lösenord via konto",
    "account.getPasswordByEmail": "Återställ lösenord via e-post",

    "account.sendEmailTips": "Verifieringskod skickad till e-post, kolla din inkorg",
    "account.name": "Kontonamn",
    "account.newPassword": "Nytt lösenord",
    "account.confirmNewPassword": "Bekräfta nytt lösenord",
    "account.nameTips": "Ange kontonamn",
    "account.passwordModifySuccess": "Lösenordsändring lyckades",
    "account.emailCode": "E-postverifieringskod",
    "account.emailCodeTips": "Ange e-postverifieringskod",
    "account.emailCodeTips2": "Ogiltig e-postverifieringskod",
    "account.emailModifySuccess": "Lösenordsändring lyckades",
    "account.passworTips1": "Ditt lösenord har återställts!",
    "account.passwordTips11": "Ange bekräftelselösenord",
    "account.passwordTips12": "Ange nytt lösenord",
    "account.nickname": "Användarnamn",
    "account.modifyNickname": "Ändra användarnamn",
    "account.modifyNicknameSuccess": "Användarnamn ändrat!",
    "account.nicknameTips": "Ange användarnamn",
    'account.nicknameError': 'Ändring av användarnamn misslyckades!',

    "account.login": 'Logga in',
    'account.quickRegister': 'Snabbregistrering',
    'account.sendCode': 'Skicka kod',
    'account.sendTips': 's kan skickas igen',
    "account.sendEmailIng": 'Skickar e-post, var god vänta...',
    'account.emailNotEmpty': 'E-postadress får inte vara tom',
    'account.registerAccount': 'Registrera konto',
    'account.registerWelcome': 'Välkommen till SusprSafe',
    'account.usernameLimit': 'Användarnamn måste börja med en bokstav och kan bara innehålla bokstäver, siffror och understreck, 5-15 tecken långt.',

    'copyright.desc2': 'Webbplatsregistrering: Yue ICP-bei 2021169764',

    'editUserInfo.editUserInformation': 'Redigera användarinformation',
    'editUserInfo.modifyUsername': 'Ändra användarnamn',
    'editUserInfo.changePictures': 'Ändra profilbild',
    'editUserInfo.savePicturesSuccess': 'Profilbild sparad',
    'editUserInfo.saveError': 'Sparning misslyckades',
    'editUserInfo.pictureLimit':'Bild måste vara mindre än 2MB',
    'editUserInfo.uploadPicture':'Ladda upp profilbild',
    'editUserInfo.picturePreview':'Förhandsgranska',

    'editUserInfo.bindPhoneNumber': 'Bind telefonnummer',
    'editUserInfo.bindEmail': 'Bind e-post',
    'editUserInfo.changePassword': 'Ändra lösenord',

    'editUserInfo.notificationSettings': 'Notisinställningar',
    'editUserInfo.editAccount': 'Redigera kontoinformation',
    'editUserInfo.waitBingting': 'Binder, var god vänta...',
    'editUserInfo.collapse': 'Dölj',
    'editUserInfo.modifyBinding': 'Ändra bindning',

    'editUserInfo.emailAddress': 'E-postadress',
    'editUserInfo.tips1': 'E-postbindning lyckades',
    'editUserInfo.tips2': 'Sparning misslyckades',
    'editUserInfo.tips3': 'Skickar e-postverifieringskod, var god vänta...',
    'editUserInfo.tips4': 'Verifieringskod skickad till e-post xxxx, kolla din inkorg',
    'editUserInfo.tips5': 'Verifieringskod kunde inte skickas!',
    'editUserInfo.tips6': 'Telefonnummer redan bundet',
    'editUserInfo.tips7': 'E-post redan bunden',
    'editUserInfo.emailTips1': 'Ange e-postadress',
    'editUserInfo.emailTips2': 'Ogiltig e-postadressformat',
    'editUserInfo.emailTips3': 'xxxxs kan skickas igen',
    'editUserInfo.emailTips4': 'Skicka kod',
    'editUserInfo.emailTips5': 'E-postverifieringskod får inte vara tom',
    'editUserInfo.emailTips6': 'Ogiltig e-postverifieringskod',
    'editUserInfo.emailCode': 'E-postverifieringskod',
    'editUserInfo.save': 'Spara',

    'editUserInfo.phoneTips1': 'Telefonnummer bindning lyckades',
    'editUserInfo.phoneTips2': 'Skickar SMS-verifieringskod, var god vänta...',
    'editUserInfo.phoneTips3': 'SMS-verifieringskod skickad till telefon xxxx, kolla dina meddelanden',
    'editUserInfo.phoneTips4': 'SMS-verifieringskod kunde inte skickas!',
    'editUserInfo.phoneTips5': 'Ange telefonnummer',
    'editUserInfo.phoneTips6': 'Ogiltigt telefonnummerformat',
    'editUserInfo.phoneTips7': 'Skicka SMS-verifieringskod',
    'editUserInfo.phoneTips8': 'SMS-verifieringskod',
    'editUserInfo.phoneTips9': 'Telefonverifieringskod får inte vara tom',
    'editUserInfo.phoneTips10': 'Ogiltig telefonverifieringskod',
    'editUserInfo.phone': 'Telefonnummer',


    'editUserInfo.noticeTips1': 'Kunde inte hämta notisinställningar!',
    'editUserInfo.noticeTips2': 'Notisinställningar sparade!',
    'editUserInfo.noticeTips3': 'Notis för låg batterinivå',
    'editUserInfo.noticeTips4': 'Notis när laddning slutförts',
    'editUserInfo.errorNotification': 'Felnotis',
    'editUserInfo.updateNotification': 'Uppdateringsnotis',
    'editUserInfo.monthlyStatisticsNotification': 'Månatlig statistiknotis',
    'editUserInfo.notificationMethod': 'Mottagningssätt',

    'editUserInfo.userNameTips1': 'Användarnamn sparat',
    'editUserInfo.userNameTips2': 'Sparning av användarnamn misslyckades',
    'editUserInfo.userNameTips3': 'Ange användarnamn',
    'editUserInfo.userNameTips4': 'Ogiltigt användarnamnsformat. Måste bestå av siffror, understreck och bokstäver.',
    'editUserInfo.userNameTips5': 'Ange användarnamn',
    'editUserInfo.userNameTips6': 'Sparar, var god vänta...',
    'editUserInfo.userName': 'Användarnamn',

    'editUserInfo.avatorTips': 'Klicka för att ändra profilbild',
    'editUserInfo.verifyCodeTips1': 'Ange den verifieringskod du fått:',
    'editUserInfo.verifyCodeTips2': 'För din kontos säkerhet, klicka på knappen för att skicka verifieringskod till originaltelefonnumret:',
    'editUserInfo.verifyCodeTips3': 'Skicka kod',
    'editUserInfo.verifyCodeTips4': 'Originaltelefon verifierad, ange nytt telefonnummer att binda',
    'editUserInfo.verifyCodeTips5': 'För din kontos säkerhet, klicka på knappen för att skicka verifieringskod till originale-posten:',
    'editUserInfo.verifyCodeTips6': 'Originale-post verifierad, ange ny e-postadress',
    'editUserInfo.verifyCodeTips7': 'Gammalt lösenord',
    'editUserInfo.verifyCodeTips8': 'Bind e-post först!',
    'editUserInfo.verifyCodeTips9': 'Verifieringskod skickad till e-post, kolla din inkorg',
    "editUserInfo.verifyCodeTips10": ', kommer automatiskt att omdirigeras till inloggningssidan',

    "hems.notice.title": "Notisrubrik",
   "hems.notice.content": "Notisinnehåll",
   "hems.notice.operate": "Åtgärd",
   "hems.notice.noRead": "Oläst",
   "hems.notice.read": "Läst",
   "hems.notice.warning": "Påminnelse",
   "hems.notice.error": "Avvikelse",
   "hems.notice.success": "Statistikavräkning",
   "hems.notice.sys": "Systeminformation",
   "hems.notice.operateSuccess": "Åtgärd lyckades",
   "hems.notice.operateTips": "Välj objekt att hantera",

    // Hemsida
   "hems.home.selfuseRate": "Självförbrukningsgrad",
   "hems.home.percent": "Procent",
   "hems.home.todayData": "Dagens data",
   "hems.home.todayPowerGeneration": "Dagens elproduktion",
   "hems.home.salesIncome": "Intäkter från elförsäljning",
   "hems.home.saved": "Har sparat",
   "hems.home.reduce": "Minskad kolfotavtryck",
   "hems.home.tips1": "Ingen data, du har inte bundit xxxx",
   "hems.home.criticalLoad": "Kritisk last",
   "hems.home.keyVoltage": "Kritisk spänning",
   "hems.home.householdLoad": "Hushållslast",
   "hems.home.householdVoltage": "Hushållsspänning",
   "hems.home.generalLoad": "Generell last",
   "hems.home.generalVoltage": "Generell spänning",
   "hems.home.batteryHealth": "Batterihälsa",
   "hems.home.averageTemp": "Medeltemperatur",
   "hems.home.gridLoad": "Nätbelastning",
   "hems.home.toggeleDataSource": "Visad data har bytts till:",
   "hems.home.toggleTips": "Är du säker på att byta?",
   "hems.home.modeSending": "Lägekommando skickas, var god vänta...",
   "hems.home.modeSuccess": "Lägebyteskommando skickat!",
   "hems.home.isOnline": "Är online",
   "hems.home.useStatus": "Användningsstatus",
   "hems.home.workModeText": 'Aktuellt arbetsläge:',
   "hems.home.toggleDataSourceText": 'Visad data har bytts till:',
   "hems.ev.charge.status": "Laddningsstatus",
   "hems.ev.charge.time": "Laddningstid",
   "hems.ev.charge.count": "Realtids laddningsmängd",
   "hems.ev.charge.status.empty":"Ledig",
   "hems.ev.charge.status.ing":"Laddar med kabel inkopplad",
   "hems.ev.charge.status.null":"Kabel inkopplad, laddar inte",
   "hems.ev.charge.status.error":"Fel",
   "hems.hour":"timme",
   "hems.minue":"minut",
   "hems.ev.chagre.number": "Laddstationsnummer",

   // Användarhandledning
   "hems.userGuide.selfUse": "Självförbrukning",
   "hems.userGuide.selfUseTips": "Prioriterar solcellsproduktion, kompletterar från nätet vid behov",
   "hems.userGuide.economyMode": "Ekonomiskt läge",
   "hems.userGuide.economyModeTips": "Optimerar energianvändning baserat på elpriser",
   "hems.userGuide.emergencyMode": "Nödläge",
   "hems.userGuide.emergencyModeTips": "Prioriterar strömförsörjning till kritisk last",

   // Diagramssida
   "hems.history.energyStatistics": "Energistatistik",
   "hems.history.revenueStatistics": "Intäktsstatistik",
   "hems.history.greenStatistics": "Grön miljöpåverkan",
   "hems.history.revenueTitle": "Total intäkt från elförsäljning",
   "hems.history.savingsTitle": "Total besparing",
   "hems.history.carbonTitle": "Total minskad koldioxidutsläpp",
   "hems.history.day": "Dag",
   "hems.history.month": "Månad",
   "hems.history.year": "År",
   "hems.history.beforeDay": "Igår",
   "hems.history.afterDay": "Imorgon",
   "hems.history.beforeMonth": "Förra månaden",
   "hems.history.afterMonth": "Nästa månaden",
   "hems.history.beforeYear": "Förra året",
   "hems.history.afterYear": "Nästa året",
   "hems.history.totalUse": 'Total användning',
   "hems.history.fullScreen": 'Fullskärm',
   "hems.history.timeSelect": "Datumval",
   "sync.tips1": "Synkroniseringskommando skickat!",
   "sync.tips2":"Datasynkronisering pågår, kan ta upp till en halvtimme p.g.a. datamängd, återkom senare~",
   "sync.tips3": "Datasynkronisering kan vara fördröjd. Om data verkar felaktig, klicka:",
   "sync.tips4": "Synkronisera data",

   "charge.info": "Laddstationsinformation",
    "news.loading": 'Laddar...',
    "news.noMore": 'Inget mer',
    "hems.pv.power": 'Solcellsproduktion',

  // UEH specifik
  "ueh.sellPower": "Försåld elmängd",

  "menu.home": "Hemsida",
  "menu.history": "Historik",
  "menu.device": "Utrustning",
  "menu.settings": "Inställningar",
  "menu.messageCenter": "Meddelanden",
  "menu.help": "Hjälp & Support",
  "menu.mine": "Min sida",


  "mine.userSetting": "Användarinställningar",
  "mine.terminalSetting": "Grundinställningar slutenhet",
  "mine.uploadCloud": "Säkerhetskopiera data till molnet",
  "mine.changeVersion": "Sök efter uppdateringar",
  "mine.language": "Byt språk",
  "mine.about": "Om",
  "mine.feedback": "Feedback",
  "mine.logout": "Logga ut",
  "mine.logoutAccount": "Avregistrera konto",

  "mine.logoutAccountTips": "Avregistrera konto med namnet []",
  "mine.logoutAccountTips1": "Avregistrera [] bundet konto",
  "mine.logoutAccountCare": "Viktigt vid avregistrering:",
  "mine.logoutAccountCare1": "1. Kontot är i säkert tillstånd",
  "mine.logoutAccountCare1-1": "Kontot används normalt, inget risk för stöld, överträdelser, avstängning etc.",
  "mine.logoutAccountCare2": "2. Auktorisationer/bindningar har tagits bort",
  "mine.logoutAccountCare2-1": "Kontot har avslutat auktorisationer med tredjepartstjänster.",
  "mine.logoutAccountCare3": "3. Kontot kan inte återvinnas efter avregistrering, all data raderas",
  "mine.logoutAccountCare3-1": "Efter avregistrering raderas all data och bundna telefonnummer/e-postadresser permanent.",
  "mine.confirmLogout": "Bekräfta avregistrering",
  "mine.logoutSuccess": "Konto borttaget!",

  "mine.feedbackIssues": "Rapportera problem",
  "mine.feedQuantity": "Antal",
  "mine.feedAmount": "Max 9 bilder, max 1MB/bild",

  "mine.notice.fail": "Kunde inte hämta notisinställningar!",
  "mine.notice.saveSuccess": "Notisinställningar sparade!",
  "mine.notice.saveFail": "Sparning misslyckades!",
  "mine.notice.title": "Notisinställningar",
  "mine.notice.batteryLow": "Notis för lågt batteri",
  "mine.notice.chargingFinish": "Notis när laddning slutförts",
  "mine.notice.error": "Felnotis",
  "mine.notice.update": "Uppdateringsnotis",
  "mine.notice.monthly": "Månatlig statistiknotis",
  "mine.notice.receiveType": "Mottagningssätt",

  "mine.language.welcome": "Välkommen till SusprSafe",
  "mine.language.desc1": "Välj språkversion baserat på din region",
  "mine.language.desc2": "Du kan ändra detta när som helst i appinställningarna",

  "mine.userInfo.avatar":"Profilbild",
  "mine.userInfo.nickname":"Smeknamn",
  "mine.userInfo.password":"Lösenord",
  "mine.userInfo.changePassword":"Ändra lösenord",
  "mine.userInfo.setPassword":"Ställ in lösenord",
  "mine.userInfo.phoneNumber":"Telefonnummer",
  "mine.userInfo.bindPhone":"Bind telefonnummer",
  "mine.userInfo.bindEmail":"Bind e-post",
  "mine.loginExpired":"Inloggning utgången, logga in igen",
  "mine.userInfo.title":"Användarinformation",
  "mine.userInfo.bind":"Bind",
  "mine.userInfo.modify": "Ändra",
  "mine.userInfo.modifyNickname":"Ändra smeknamn",
  "mine.userInfo.userNickname":"Användarsmeknamn",
  "mine.userInfo.selectPic":"Välj bild att ladda upp",
  "mine.userInfo.saveSuccess":"Sparad",
  "mine.userInfo.uploadFail":"Uppladdning misslyckades",
  "mine.userInfo.avatarSaveSuccess":"Profilbild sparad",
  "mine.userInfo.nameTips1":"Smeknamn får inte vara tomt",
  "mine.userInfo.nameTips2":"Ange smeknamn",

  "common.pleaseSelect": "Välj",
  "question.commonQuestions": "Vanliga frågor",
  "account.toggleLanguage": 'Byt språk',
  "account.localConnection": "Lokal anslutning",
  "account.selectLanguage": 'Välj språk',
  "account.sendEmailToast": "Verifieringskod skickad till e-post xxx, kolla din inkorg",
  "account.emailError": "Ogiltig e-postadress",
  "account.sendEmailFail": "Skickning misslyckades, försök igen",

  "common.submitting": "Skickar, var god vänta...",

  "device.page.noData": "Ingen data tillgänglig, denna sida kräver appen för förhandsgranskning"

,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};